// src/components/sections/ValuesDetailSection.jsx
import React from 'react';
import ValueIcon from '../ui/ValueIcon';

/**
 * Values detail section displayed on the Values page
 * Styled to match the Mission & Vision and Our Approach sections from Firm page
 */
const ValuesDetailSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold text-gray-900">How Our Values Guide Our Practice</h2>
          <div className="w-24 h-1 bg-secondary mx-auto my-4"></div>
        </div>

        <div className="max-w-5xl mx-auto">
          <p className="text-lg text-gray-700 text-center mb-16 max-w-3xl mx-auto">
            At AMV Law, our core values aren't just words on a page—they are the fundamental 
            principles that guide every decision we make and every client we represent. These values 
            shape our approach to legal practice and define who we are as professionals.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Ethics First</h3>
                <p className="text-gray-600 text-center">
                  We never compromise on our ethical standards, even when faced with difficult situations.
                </p>
              </div>
            </div>
            
            <div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Continuous Growth</h3>
                <p className="text-gray-600 text-center">
                  We constantly evolve our knowledge and skills to better serve our clients' needs.
                </p>
              </div>
            </div>
            
            <div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Client Partnership</h3>
                <p className="text-gray-600 text-center">
                  We view our clients as partners in achieving their legal objectives and desired outcomes.
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-20 bg-white p-8 rounded-lg shadow-sm">
            <h3 className="text-2xl font-bold text-primary mb-4">Our Commitment</h3>
            <p className="text-lg text-gray-700">
              These values form the foundation of our practice and our promise to every client we serve. 
              They are not aspirational goals but daily commitments that define our professional identity 
              and guide our approach to legal practice.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuesDetailSection;